import type { DashboardFilters, TimeRange } from '@delivery-metrics/shared';
import { useCallback, useState } from 'react';

const createDefaultTimeRange = (): TimeRange => ({
  start: new Date(Date.UTC(new Date().getUTCFullYear(), 0, 1)),
  end: new Date(),
  preset: 'ytd',
});

const createDefaultFilters = (): DashboardFilters => ({
  timeRange: createDefaultTimeRange(),
  units: [],
  teams: [],
  repositories: [],
  programs: [],
});

/**
 * Hook for managing dashboard filters state
 */
export function useDashboardFilters() {
  const [filters, setFilters] = useState<DashboardFilters>(
    createDefaultFilters()
  );

  const updateFilters = useCallback((newFilters: Partial<DashboardFilters>) => {
    setFilters(prev => ({
      ...prev,
      ...newFilters,
    }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters(createDefaultFilters());
  }, []);

  return {
    filters,
    updateFilters,
    resetFilters,
  };
}
